export const USER_TYPE = Object.freeze({
  VBC: 'VBC',
  VCP: 'VCP'
});
